export const skillsLogos = [
  { icon: "devicon-javascript-plain", name: "JavaScript" },
  { icon: "devicon-typescript-plain", name: "TypeScript" },
  { icon: "devicon-angularjs-plain-wordmark", name: "Angular" },
  { icon: "devicon-nodejs-plain-wordmark", name: "Node.js" },
  { icon: "devicon-python-plain-wordmark", name: "Python" },
  { icon: "devicon-jquery-plain-wordmark", name: "jQuery" },
  { icon: "devicon-react-original-wordmark", name: "React" },
  { icon: "devicon-django-plain", name: "Django" },
  { icon: "devicon-express-original-wordmark", name: "Express" },
  { icon: "devicon-graphql-plain-wordmark", name: "GraphQL" },
  { icon: "devicon-postgresql-plain-wordmark", name: "PostgreSQL" },
  { icon: "devicon-mongodb-plain-wordmark", name: "MongoDB" },
  { icon: "devicon-bootstrap-plain-wordmark", name: "Bootstrap" },
  { icon: "devicon-git-plain-wordmark", name: "Git" },
  { icon: "devicon-github-plain-wordmark", name: "Github" },
  { icon: "devicon-heroku-original-wordmark", name: "Heroku" },
  { icon: "devicon-amazonwebservices-plain-wordmark", name: "AWS" },
  { icon: "devicon-jenkins-plain", name: "Jenkins" },
  { icon: "devicon-karma-plain", name: "Karma" },
  { icon: "devicon-mocha-plain", name: "Mocha" },
  { icon: "devicon-html5-plain-wordmark", name: "HTML5" },
  { icon: "devicon-css3-plain-wordmark", name: "CSS3" },
  { icon: "devicon-vscode-plain-wordmark", name: "VSCode" },
];
